import React, { Component, Fragment } from "react";

// {merchant,merchantTransactions}

class Index extends Component {
  render() {
    return (
      <Fragment>
        {(window.location.href = "https://reports.prepaidplus.co.bw/")}
      </Fragment>
    );
  }
}

export default Index;
